import React from 'react';
import { Pagination } from 'react-bootstrap';
import {
  BsChevronDoubleLeft,
  BsChevronDoubleRight,
  BsChevronLeft,
  BsChevronRight,
} from 'react-icons/bs';
import './PageNumber.module.css';

const HALF_RANGE = 3;

/**
 * @param {{pages: number, value: number, onChange: (value: number)}}
 */
export default function PageNumber({ className, pages, value, onChange }) {
  const prevPage = () => onChange(Math.max(value - 1, 0));
  const nextPage = () => onChange(Math.min(value + 1, pages - 1));
  const firstPage = () => onChange(0);
  const lastPage = () => onChange(pages - 1);

  return (
    <div className="d-flex justify-content-center align-items-center">
      <Pagination className="pagination-custom">
        {/* Double Left Arrow */}
        {value > HALF_RANGE && (
          <Pagination.First className="d-block" onClick={firstPage}>
            <BsChevronDoubleLeft />
          </Pagination.First>
        )}

        {/* Single Left Arrow */}
        <Pagination.Prev onClick={prevPage}>
          <BsChevronLeft />
        </Pagination.Prev>

        {/* Page Numbers */}
        {Array.from({ length: pages }, (_, i) => {
          // This allows the css to handle changing the range based on breakpoints
          const getDynamicClassName = () => {
            if (value - i < -2 || value - i > 2) return 'd-none d-md-block';
            else if (value - i < -1 || value - i > 1) return 'd-none d-sm-block';
            else return '';
          };

          if (
            i <= Math.max(value + HALF_RANGE, HALF_RANGE * 2) &&
            i >= Math.min(value - HALF_RANGE, pages - 1 - HALF_RANGE * 2)
          )
            return (
              <Pagination.Item
                key={i}
                className={getDynamicClassName()}
                data-selected={i === value}
                onClick={() => onChange(i)}
              >
                {i + 1}
              </Pagination.Item>
            );
          else return null;
        })}

        {/* Single Right Arrow */}
        <Pagination.Next onClick={nextPage}>
          <BsChevronRight />
        </Pagination.Next>

        {/* Double right arrow */}

        {value < pages - HALF_RANGE - 1 && (
          <Pagination.Last className="d-block" onClick={lastPage}>
            <BsChevronDoubleRight />
          </Pagination.Last>
        )}
      </Pagination>
    </div>
  );
}
